/**
 * Created by Elaine Lopez on 4/19/2019.
 */

import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '@app/services/storage.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.storageService.isAuthenticated()) {
        // logged in so return true
        return true;
      }
      // not logged in so redirect to home page
      this.storageService.authorizeSubject.next({ 'authorize': false, 'url': route.data.route });
      this.router.navigateByUrl(this.router.url);
      return false;
    }
    return true;
  }

}
